export type UserAuthority = 'ROLE_ADMIN' | 'ROLE_AFFILIATE' | 'ROLE_MANAGER' | 'ROLE_SUPER_ADMIN' | 'VIEW_DEPOSITS' | 'VIEW_NET_CASH';
export const ROLE_ADMIN: UserAuthority = 'ROLE_ADMIN';
export const ROLE_SUPER_ADMIN: UserAuthority = 'ROLE_SUPER_ADMIN';